///**
//=========================================================
//* Material Dashboard 2 PRO React - v2.1.0
//=========================================================

//* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
//* Copyright 2022 Creative Tim (https://www.creative-tim.com)

//Coded by www.creative-tim.com

// =========================================================

//* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
//*/

//// Material Dashboard 2 PRO React Base Styles
//import colors from "assets/theme/base/colors";
//import rgba from "assets/theme/functions/rgba";

//const { info, dark, background, light, white, text } = colors;

//const globals = {
//  '@import url("https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap")': {},
//  html: {
//    scrollBehavior: "smooth",
//  },
//  body: {
//    "--app-bg-default": background.default,
//    "--app-surface": background.card,
//    "--app-surface-muted": background.muted,
//    "--app-surface-elevated": background.elevated,
//    "--app-border": rgba(dark.main, 0.12),
//    "--app-border-strong": rgba(dark.main, 0.18),
//    "--app-shadow-card": `0 18px 45px ${rgba(dark.main, 0.08)}`,
//    "--app-text-primary": dark.main,
//    "--app-text-secondary": text.main,
//    "--app-placeholder": rgba(dark.main, 0.52),
//    "--app-icon-color": text.main,
//    "--app-field-bg": rgba(white.main, 0.9),
//    "--app-field-bg-hover": white.main,
//    "--app-field-text": dark.main,
//    "--app-field-placeholder": rgba(dark.main, 0.52),
//    "--app-field-border": rgba(dark.main, 0.12),
//    "--app-field-border-hover": rgba(info.main, 0.35),
//    "--app-field-border-focus": info.main,
//    "--app-field-ring": rgba(info.main, 0.12),
//    background:
//      `radial-gradient(circle at top left, ${rgba(info.main, 0.12)}, transparent 32%), linear-gradient(180deg, ${light.main} 0%, ${background.default} 50%, ${background.muted} 100%)`,
//    color: dark.main,
//  },
//  "*, *::before, *::after": {
//    margin: 0,
//    padding: 0,
//    boxSizing: "border-box",
//  },
//  "#root": {
//    minHeight: "100vh",
//  },
//  "::selection": {
//    backgroundColor: rgba(info.main, 0.18),
//  },
//  "a, a:link, a:visited": {
//    textDecoration: "none !important",
//  },
//  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
//    color: `${dark.main} !important`,
//    transition: "color 150ms ease-in !important",
//  },
//  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
//    color: `${info.main} !important`,
//  },
//  "input, textarea, .MuiInputBase-input, .MuiInput-input, .MuiOutlinedInput-input, .MuiInputBase-inputMultiline, .MuiAutocomplete-input": {
//    color: "var(--app-field-text) !important",
//    WebkitTextFillColor: "var(--app-field-text) !important",
//    caretColor: "var(--app-field-text) !important",
//  },
//  "input::placeholder, textarea::placeholder, .MuiInputBase-input::placeholder, .MuiOutlinedInput-input::placeholder, .MuiAutocomplete-input::placeholder": {
//    color: "var(--app-field-placeholder) !important",
//    opacity: "1 !important",
//  },
//  ".MuiInputLabel-root, .MuiFormLabel-root": {
//    color: `${rgba(dark.main, 0.66)} !important`,
//  },
//  ".MuiInputLabel-root.Mui-focused, .MuiFormLabel-root.Mui-focused": {
//    color: `${info.main} !important`,
//  },
//  ".MuiInputBase-root, .MuiOutlinedInput-root, .MuiAutocomplete-inputRoot, .MuiSelect-select, .MuiOutlinedInput-notchedOutline": {
//    backgroundColor: "var(--app-field-bg) !important",
//    color: "var(--app-field-text) !important",
//    borderColor: "var(--app-field-border) !important",
//  },
//  ".MuiOutlinedInput-notchedOutline, .MuiInputBase-root fieldset": {
//    borderColor: "var(--app-field-border) !important",
//  },
//  ".MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, .MuiInputBase-root:hover fieldset": {
//    borderColor: "var(--app-field-border-hover) !important",
//  },
//  ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiInputBase-root.Mui-focused fieldset": {
//    borderColor: "var(--app-field-border-focus) !important",
//  },
//  ".MuiAutocomplete-popupIndicator, .MuiAutocomplete-clearIndicator, .MuiSelect-icon, .MuiSvgIcon-root, .material-icons, .material-icons-round, .MuiIconButton-root": {
//    color: "var(--app-icon-color) !important",
//  },
//  "input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, textarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus": {
//    WebkitTextFillColor: "var(--app-field-text) !important",
//    caretColor: "var(--app-field-text) !important",
//    WebkitBoxShadow: "0 0 0 1000px var(--app-field-bg) inset !important",
//    transition: "background-color 9999s ease-in-out 0s",
//  },
//};

//export default globals;


/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React Base Styles
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";

const { info, dark, background, light } = colors;

const globals = {
  '@import url("https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap")': {},
  html: {
    scrollBehavior: "smooth",
  },
  body: {
    background:
      `radial-gradient(circle at top left, ${rgba(info.main, 0.12)}, transparent 32%), linear-gradient(180deg, ${light.main} 0%, ${background.default} 50%, ${background.muted} 100%)`,
    color: dark.main,
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },
  "#root": {
    minHeight: "100vh",
  },
  "::selection": {
    backgroundColor: rgba(info.main, 0.18),
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
};

export default globals;
